import React from "react";
import Typography from "../../components/Typography/Typography";
import OnboardingLayout from "../../layouts/OnboardingLayout/OnboardingLayout";

const ErrorFallback = ({ error, resetErrorBoundary }) => {
  return (
    <div className="overflow-y-hidden">
      <OnboardingLayout hasProgress={false} nextType={"register"}>
        <div className="h-full pt-12 pb-14 md:mx-auto md:w-[40rem] w-auto px-4 relative">
          <div className="flex flex-col gap-2 md:gap-4">
            <Typography
              weight="sb"
              desktopSize="48"
              size="32"
              family="serif"
              align="center"
              color="black"
            >
              {error ||
                "Oops! Hai smarrito la strada… proprio come quella bibliografia introvabile!"}
            </Typography>
            <Typography
              color="gray-600"
              desktopSize="20"
              size="16"
              align="center"
            >
              Non preoccuparti, non dovrai riscrivere tutto da capo, basta{" "}
              <button
                onClick={() => window.history.back()}
                className="text-accent font-sb underline cursor-pointer"
              >
                tornare indietro!
              </button>
            </Typography>
          </div>

          <div className="absolute w-full h-full">
            <img
              src="/assets/images/illustrations/lost.png"
              alt="Illustrazione di una persona che cerca documenti"
              className="absolute md:bottom-14 bottom-20 left-1/2 -translate-x-1/2 w-[25rem] h-[25rem] object-contain"
            />
          </div>
        </div>
      </OnboardingLayout>
    </div>
  );
};

export default ErrorFallback;
